import { Links, Meta, Outlet, Scripts, ScrollRestoration, useRouteError } from "react-router";

import { cn } from "~/ui";

import styles from "./styles/global.css?url";

export const links = () => [
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" as const },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500&display=swap",
  },
  { rel: "stylesheet", href: styles },
  { rel: "icon", href: "/favicon.ico" },
];

export const meta = () => [
  { title: "Dynamic Form Playground" },
  { name: "robots", content: "noindex, nofollow" },
];

function App() {
  return (
    <html lang="en" className="h-full">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1.0,viewport-fit=cover" />
        <Meta />
        <Links />
      </head>

      <body className={cn("h-full font-sans antialiased")}>
        <Outlet />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export function ErrorBoundary() {
  const error = useRouteError();

  let title = "Something went wrong";
  let message = "There was an unexpected error - please reload and try again.";

  if (error instanceof Error) {
    title = error.name || "Error";
    message = error.message;
  }

  return (
    <html lang="en">
      <head>
        <title>Dynamic Form Playground - Error</title>
        <Meta />
        <Links />
      </head>
      <body className="flex h-full items-center justify-center p-4">
        <div className="w-full max-w-md text-center">
          <h1 className="mb-4 text-2xl font-bold">{title}</h1>
          <p className="mb-6 text-muted-foreground">{message}</p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-lg bg-primary px-4 py-2 text-primary-foreground hover:bg-primary/90"
          >
            Reload Page
          </button>
        </div>
        <Scripts />
      </body>
    </html>
  );
}

export default App;
